import { pushRoute } from '../../../lib/router.js';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Field } from 'react-final-form';

import { SurveyCreator, SurveyCreatorComponent } from 'survey-creator-react';
import {
  applyBrandSettings,
  CUSTOM_DEFAULT_BRAND_COLOR,
  CUSTOM_DEFAULT_FONT,
  CUSTOM_OPTIONS_SURVEY,
  formatedTemplate,
  STATUSES_TEMPLATE,
} from '../../../containers/change-insights/utils/index.jsx';
import RadioAdapter from '../../RadioAdapter.jsx';

const OrgSurveySettingForm = ({
  handleSubmit,
  handlePreview,
  handleChangeStatus,
  organization,
  submitting,
  loading,
  status,
  errorsFields,
  data,
}) => {
  const [creator, setCreator] = useState(null);

  useEffect(() => {
    if (!creator) {
      const creatorNew = new SurveyCreator(CUSTOM_OPTIONS_SURVEY);
      if (data?.surveyJson) {
        creatorNew.JSON = formatedTemplate(data);
      }
      creatorNew.onNotify.add(() => {});
      setCreator(creatorNew);
    }
  }, [data]);

  const navigateToSettings = () => pushRoute('organization/custom-settings');

  const handleClick = () => {
    const sendData = creator.JSON;
    handleSubmit(sendData);
  };

  useEffect(() => {
    if (organization) {
      applyBrandSettings({
        brandColor: CUSTOM_DEFAULT_BRAND_COLOR,
        fontName: CUSTOM_DEFAULT_FONT,
      });
    }
  }, [organization]);

  useEffect(() => {
    // TODO: remove after update next/react version, code need for correctly drag element question inside block
    const handleMouseMove = (event) => {
      const { body } = document;
      const nextDiv = body.nextElementSibling;
      const mouseX = event.clientX + window.scrollX;
      const mouseY = event.clientY + window.scrollY;

      if (nextDiv?.tagName === 'DIV') {
        nextDiv.style.top = `${mouseY}px`;
        nextDiv.style.left = `${mouseX}px`;
        nextDiv.style.minHeight = '40px';
      }
    };

    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <React.Fragment>
      <div className="m-b-60" id="surveyCreatorContainer">
        {creator ? <SurveyCreatorComponent creator={creator} /> : null}
      </div>
      <hr />
      <div style={{ padding: '24px 84px' }}>
        <div className="m-b-48">
          <h4 className="text-muted m-b-24">Select status</h4>
          {STATUSES_TEMPLATE.map((radio) => (
            <React.Fragment>
              <Field
                key={radio.name}
                name={radio.name}
                component={RadioAdapter}
                label={radio.label}
                type="radio"
                checked={status === radio.name}
                onChange={() => handleChangeStatus(radio.name)}
              />
              <p className="text-muted m-l-32" style={{ marginTop: '-10px' }}>
                {radio.description}
              </p>
            </React.Fragment>
          ))}
        </div>
        <div>
          {errorsFields?.message ? (
            <p className="text-danger">{errorsFields.message}</p>
          ) : null}
        </div>
        <div>
          <div>
            <div className="flex" style={{ justifyContent: 'space-between' }}>
              <div>
                <Button onClick={navigateToSettings} bsStyle="default">
                  Cancel
                </Button>
                <Button
                  className="m-l-12"
                  bsStyle="primary"
                  disabled={loading}
                  onClick={handleClick}
                >
                  {submitting ? 'Saving...' : 'Save'}
                </Button>
              </div>
              <div>
                <Button
                  bsStyle="success"
                  className="add-activity-button"
                  onClick={() => handlePreview(creator.JSON)}
                >
                  Preview in New Tab
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default OrgSurveySettingForm;
